import React from 'react';

interface LegalServiceSchemaProps {
  pageType: 'terms' | 'privacy' | 'medical-disclaimer';
  title: string;
  description: string;
  url: string;
}

const LegalServiceSchema: React.FC<LegalServiceSchemaProps> = ({
  pageType,
  title,
  description,
  url
}) => {
  const getLegalServiceType = () => {
    switch (pageType) {
      case 'terms':
        return 'Terms of Service';
      case 'privacy':
        return 'Privacy Policy';
      case 'medical-disclaimer':
        return 'Medical Disclaimer';
      default:
        return 'Legal Information';
    }
  };

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "LegalService",
    "name": `Women and the Way - ${getLegalServiceType()}`,
    "description": description,
    "url": url,
    "provider": {
      "@type": "Organization",
      "name": "Women and the Way",
      "url": "https://womenandtheway.com.au",
      "logo": {
        "@type": "ImageObject",
        "url": "https://womenandtheway.com.au/watw_logo.webp"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "700 Nicklin Way",
        "addressLocality": "Currimundi",
        "addressRegion": "QLD",
        "postalCode": "4551",
        "addressCountry": "AU"
      },
      "telephone": "+61 415 537 784",
      "email": "womenandtheway@gmail.com"
    },
    "areaServed": {
      "@type": "City",
      "name": "Sunshine Coast",
      "addressRegion": "QLD",
      "addressCountry": "AU"
    },
    "serviceType": getLegalServiceType(),
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name": "Legal Information Services",
      "itemListElement": [
        {
          "@type": "Offer",
          "itemOffered": {
            "@type": "Service",
            "name": getLegalServiceType(),
            "description": description
          }
        }
      ]
    },
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": url,
      "name": title,
      "description": description
    }
  };

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaData)}
    </script>
  );
};

export default LegalServiceSchema; 